import { useContext } from 'react';
import { ConfigContext } from 'antd/es/config-provider';

export const useAntdConfig = () => {
    const antdConfig = useContext(ConfigContext);

    return antdConfig;
};
